
/* Client-side improvements for the 03.11 review copy. */
(() => {
  'use strict';
  const email='contact@sheriffadel.de';
  const confirmedMessage='Fast geschafft! Bitte bestätige deine E-Mail-Adresse über den Link in unserer E-Mail. Falls du sie nicht findest, schau auch in deinem Spam-Ordner nach.';
  let feedbackTimer=0;
  const toast=(message,type='pending',form=null)=>{
    let el=document.querySelector('.sf-newsletter-toast');
    if(!el){el=document.createElement('div');el.className='sf-newsletter-toast';el.setAttribute('role','status');el.setAttribute('aria-live','polite');document.body.appendChild(el);}
    const button=form?.querySelector('button[type="submit"]') || document.querySelector('[data-sf-subscription] button[type="submit"]');
    el.replaceChildren();
    if(type==='success'){
      const bold=document.createElement('strong');bold.textContent='Fast geschafft!';el.append(bold,document.createTextNode(message.replace(/^Fast geschafft!\s*/,'').trim()));
    } else el.textContent=message;
    el.classList.remove('sf-success','sf-error');
    if(type==='success')el.classList.add('sf-success');
    else if(type==='error'||type==='challenge')el.classList.add('sf-error');
    if(type==='challenge'&&form){
      const retry=document.createElement('button');retry.type='button';retry.className='sf-newsletter-native-retry';retry.textContent='Sicherheitsprüfung durchführen';
      retry.addEventListener('click',()=>{
        form.dataset.sfNewsletterNativeFallback='1';
        form.querySelector('button[type="submit"]')?.removeAttribute('disabled');
        form.requestSubmit();
      });
      el.append(retry);
    }
    const rect=button?.getBoundingClientRect();
    if(rect){
      const width=Math.min(390,innerWidth-30);
      el.style.width=width+'px';
      el.style.left=Math.max(15,Math.min(innerWidth-width-15,rect.left+rect.width/2-width/2))+'px';
      // Below the button where possible; otherwise just above it.
      const height=Math.max(78,Math.min(130,el.getBoundingClientRect().height||92));
      const below=rect.bottom+10;
      el.style.top=(below+height<innerHeight-12?below:Math.max(12,rect.top-height-10))+'px';
    }
    requestAnimationFrame(()=>el.classList.add('sf-show'));
    clearTimeout(feedbackTimer);
    feedbackTimer=setTimeout(()=>el.classList.remove('sf-show'),type==='error'?5200:type==='success'?4900:3000);
  };
  const ready=()=>{
    // The browser cannot discover a visitor's preferred webmail provider.
    // Use the native mail client on touch devices and Gmail web compose on desktop.
    const gmail='https://mail.google.com/mail/?view=cm&fs=1&to='+encodeURIComponent(email);
    const desktop=matchMedia('(min-width:990px) and (pointer:fine)');
    const align=()=>{
      document.querySelectorAll('a[data-sf-contact-email],a.sf-email-address,a[href^="mailto:"]').forEach(a=>{
        a.href=desktop.matches?gmail:'mailto:'+email;
        if(desktop.matches){a.target='_blank';a.rel='noopener noreferrer';}else{a.removeAttribute('target');a.removeAttribute('rel');}
      });
    };
    align();desktop.addEventListener('change',align);
    // Any success rendered after a normal Shopify POST should appear as a small bottom toast.
    if(document.querySelector('[data-sf-newsletter-success]')){const form=document.querySelector('[data-sf-newsletter-success]')?.closest('form');toast(confirmedMessage,'success',form);}
    // Theme and merchant locale may differ on an English-language iPad.
    const localizeCookies=()=>{
      const nodes=document.querySelectorAll('#shopify-pc__banner__btn-manage-prefs, [data-sf-privacy-open], button, a, [role="button"]');
      nodes.forEach(el=>{
        const raw=el.textContent||'';
        if(!/Cookie Preferences/i.test(raw)||raw.length>90)return;
        const walker=document.createTreeWalker(el,NodeFilter.SHOW_TEXT);
        let node;
        while((node=walker.nextNode())){
          if(/Cookie Preferences/i.test(node.nodeValue||''))node.nodeValue=node.nodeValue.replace(/Cookie Preferences/gi,'Cookie-Einstellungen');
        }
        for(const attr of ['aria-label','title'])if(/Cookie Preferences/i.test(el.getAttribute(attr)||''))el.setAttribute(attr,el.getAttribute(attr).replace(/Cookie Preferences/gi,'Cookie-Einstellungen'));
      });
    };
    localizeCookies();
    let cookiePending=false;
    new MutationObserver(mutations=>{
      if(cookiePending)return;
      if(!mutations.some(m=>m.type==='characterData'&&/cookie preferences/i.test(m.target?.nodeValue||'')||
        Array.from(m.addedNodes||[]).some(n=>n.nodeType===1&&(n.id?.startsWith('shopify-pc')||/Cookie Preferences/i.test(n.textContent||'')))))return;
      cookiePending=true;requestAnimationFrame(()=>{cookiePending=false;localizeCookies();});
    }).observe(document.body,{subtree:true,childList:true,characterData:true});
    // Shopify-hosted marketing confirmation has no ordinary theme template.
    // When the theme JS is present, improve that page without replacing unsubscribe controls.
    const confirmation=document.querySelector('.shopify-email-marketing-confirmation__container');
    if(confirmation){
      const heading=confirmation.querySelector('h1');
      if(heading)heading.textContent='Anmeldung bestätigt';
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();

  // Use the browser's native Shopify contact/customer form transport in a hidden
  // same-origin response frame. Unlike fetch(), this uses Shopify's normal POST path.
  // We only show green when Shopify actually confirms the subscription.
  const nativeSubmit=HTMLFormElement.prototype.submit;
  const responseFrames=new WeakMap();
  const sendNewsletter=form=>{
    if(form.dataset.sfNewsletterBusy==='1'||!form.reportValidity())return;
    form.dataset.sfNewsletterBusy='1';
    const button=form.querySelector('button[type="submit"]');
    const emailInput=form.querySelector('input[type=email]');
    const checkbox=form.querySelector('input[type=checkbox][name="contact[accepts_marketing]"]');
    const priorTarget=form.getAttribute('target');
    const began=performance.now();
    if(button)button.disabled=true;
    let iframe=responseFrames.get(form);
    if(!iframe){
      iframe=document.createElement('iframe');
      iframe.name='sf-newsletter-response-'+Math.random().toString(36).slice(2);
      iframe.title='Shopify Newsletter-Antwort';
      iframe.tabIndex=-1;
      iframe.style.cssText='position:absolute;left:-9999px;width:0;height:0;border:0;visibility:hidden;';
      document.body.appendChild(iframe);
      responseFrames.set(form,iframe);
    }
    let complete=false, pendingTimer=0, deadline=0;
    const finish=(type,message)=>{
      if(complete)return;
      complete=true;clearTimeout(pendingTimer);clearTimeout(deadline);
      if(priorTarget===null)form.removeAttribute('target');else form.setAttribute('target',priorTarget);
      delete form.dataset.sfNewsletterBusy;
      if(button)button.disabled=false;
      if(type==='success'){
        if(emailInput)emailInput.value='';
        if(checkbox)checkbox.checked=false;
        try{sessionStorage.setItem('sf-newsletter-posted','1');}catch{}
      }
      setTimeout(()=>toast(message,type,form),Math.max(0,550-(performance.now()-began)));
    };
    iframe.onload=()=>{
      if(complete)return;
      try{
        const url=iframe.contentWindow.location;
        if(url.href==='about:blank')return;
        const result=iframe.contentDocument;
        const posted=url.search.includes('customer_posted=true')||Boolean(result?.querySelector('[data-sf-newsletter-success]'));
        const challenged=/^\/challenge(?:\/|$)/.test(url.pathname)||/captcha|security challenge/i.test(result?.title||'');
        const errors=Boolean(result?.querySelector('[data-sf-subscription] .sf-form-errors'));
        if(posted&&!challenged)finish('success',confirmedMessage);
        else if(challenged)finish('challenge','Shopify verlangt eine Sicherheitsprüfung. Du kannst sie bei Bedarf öffnen.');
        else if(errors)finish('error','Shopify hat die Anmeldung abgelehnt. Bitte überprüfe die E-Mail-Adresse.');
        else finish('error','Shopify hat die Anmeldung noch nicht bestätigt. Bitte versuche es erneut.');
      }catch{
        finish('challenge','Shopify verlangt möglicherweise eine Sicherheitsprüfung. Du kannst sie öffnen.');
      }
    };
    pendingTimer=setTimeout(()=>toast('Anmeldung wird geprüft …','pending',form),460);
    deadline=setTimeout(()=>finish('challenge','Die Anmeldung wurde nicht bestätigt. Du kannst die Shopify-Prüfung öffnen.'),14000);
    const submit=()=>{
      if(complete)return;
      try{
        form.setAttribute('target',iframe.name);
        nativeSubmit.call(form);
      }catch{
        finish('error','Die Anmeldung konnte technisch nicht übermittelt werden.');
      }
    };
    // This is Shopify's documented method of wiring up CAPTCHA for native submissions.
    if(window.Shopify?.captcha?.protect){
      try{window.Shopify.captcha.protect(form,submit);}
      catch{finish('challenge','Shopifys Sicherheitsprüfung konnte nicht geladen werden.');}
    }else submit();
  };
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement)||!form.matches('[data-sf-subscription]'))return;
    if(form.dataset.sfNewsletterNativeFallback==='1'){
      delete form.dataset.sfNewsletterNativeFallback;
      form.removeAttribute('target');
      return;
    }
    event.preventDefault();event.stopImmediatePropagation();
    sendNewsletter(form);
  },true);
  const showServerError=()=>{
    const form=document.querySelector('[data-sf-subscription] .sf-form-errors')?.closest('form');
    if(form)toast('Die Newsletter-Anmeldung konnte nicht abgeschlossen werden.','error',form);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',showServerError,{once:true});else showServerError();


  // One change for each intentional trackpad impulse; ignore only inertial tail.
  // A fresh impulse can start immediately after the previous gesture slows.
  let wheelState={lastTime:0,lastAbs:0,direction:0,ready:true,lastStep:0,quiet:0};
  document.addEventListener('wheel',event=>{
    const dialog=event.target.closest?.('.sf-book-zoom-dialog[open]');
    if(!dialog||event.ctrlKey||!event.cancelable)return;
    const dx=event.deltaX,dy=event.deltaY;
    const amount=Math.abs(dx),now=performance.now(),direction=Math.sign(dx);
    if(amount<3||amount<Math.abs(dy)*1.12)return;
    if(dialog.querySelector('[data-sf-zoom-counter]')?.textContent?.trim()==='Rezensionen')return;
    event.preventDefault();event.stopImmediatePropagation();
    const gap=now-wheelState.lastTime;
    const newDirection=direction!==wheelState.direction;
    const freshImpulse=wheelState.lastAbs<=13&&amount>=Math.max(15,wheelState.lastAbs*2.2)&&now-wheelState.lastStep>120;
    if(gap>115||newDirection||freshImpulse)wheelState.ready=true;
    if(wheelState.ready&&amount>=8){
      dialog.querySelector(direction>0?'[data-sf-zoom-next]':'[data-sf-zoom-prev]')?.click();
      wheelState.ready=false;
      wheelState.lastStep=now;
    }
    wheelState.lastTime=now;
    wheelState.lastAbs=amount;
    wheelState.direction=direction;
  },{capture:true,passive:false});

  // Every storefront "Jetzt kaufen" navigation lands at the real product title.
  // Do not intercept the actual checkout form submit button.
  const scrollToPurchaseOverview=()=>{
    const title=document.querySelector('.sf-product .sf-product-desktop-heading h1');
    if(!title)return false;
    const perform=()=>{
      const header=document.querySelector('[data-sf-header]');
      const headerH=Math.max(0,Math.min(130,header?.getBoundingClientRect().height||0));
      const desiredTop=headerH+18;
      const wrapper=document.querySelector('.page-wrapper');
      const internal=Boolean(wrapper&&wrapper.scrollHeight>wrapper.clientHeight+3&&/^(auto|scroll)$/.test(getComputedStyle(wrapper).overflowY));
      if(internal){
        const target=wrapper.scrollTop+title.getBoundingClientRect().top-wrapper.getBoundingClientRect().top-desiredTop;
        wrapper.scrollTo({top:Math.max(0,target),behavior:'instant'});
      }else{
        const target=window.scrollY+title.getBoundingClientRect().top-desiredTop;
        window.scrollTo({top:Math.max(0,target),behavior:'instant'});
      }
    };
    requestAnimationFrame(()=>requestAnimationFrame(perform));
    return true;
  };
  window.sfScrollToPurchaseOverview=scrollToPurchaseOverview;
  document.addEventListener('click',event=>{
    const a=event.target.closest?.('a[href*="#sf-direct-purchase"]');
    const zoom=event.target.closest?.('[data-sf-zoom-purchase]');
    if(!a&&!zoom)return;
    if(a){
      const url=new URL(a.href,location.href);
      if(url.origin!==location.origin||url.pathname!==location.pathname)return;
    }
    if(!document.querySelector('.sf-product .sf-product-desktop-heading h1'))return;
    event.preventDefault();event.stopImmediatePropagation();
    if(a)history.replaceState(null,'','#sf-direct-purchase');
    if(zoom)zoom.closest('dialog')?.close();
    scrollToPurchaseOverview();
  },true);
  // Homepage-to-product navigation: the original browser hash jump may
  // otherwise land at the consent/button block before the page is fully laid out.
  if(location.hash==='#sf-direct-purchase'&&document.querySelector('.sf-product .sf-product-desktop-heading h1')){
    const correct=()=>scrollToPurchaseOverview();
    if(document.readyState==='complete')correct();
    else window.addEventListener('load',correct,{once:true});
    // Allow late image/font layout changes without moving unrelated pages.
    if(document.fonts?.ready)document.fonts.ready.then(correct).catch(()=>{});
  }

  // Logo uses the native homepage anchor; no custom click or scroll handler.
  // Use one sharp five-point SVG form for every custom review on all devices.
  const ns='http://www.w3.org/2000/svg',pts='12,1 14.35,8.76 22.46,8.60 15.80,13.24 18.47,20.90 12,16 5.53,20.90 8.20,13.24 1.54,8.60 9.65,8.76';
  const oneStar=(fill)=>{
    const svg=document.createElementNS(ns,'svg');
    svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('width','17');svg.setAttribute('height','17');svg.setAttribute('aria-hidden','true');
    svg.classList.add('sf-pointed-star');
    const base=document.createElementNS(ns,'polygon');
    base.setAttribute('points',pts);base.setAttribute('fill','#d6d0cb');svg.appendChild(base);
    if(fill>0){const gold=document.createElementNS(ns,'polygon');gold.setAttribute('points',pts);gold.setAttribute('fill','#e3ac24');gold.style.clipPath='inset(0 '+((1-fill)*100)+'% 0 0)';svg.appendChild(gold);}
    return svg;
  };
  const drawStars=()=>{
    document.querySelectorAll('.sf-review-stars').forEach(group=>{
      if(group.dataset.sfPointed==='true'||group.querySelector('.sf-fractional-stars'))return;
      const old=Array.from(group.children).filter(e=>e.tagName==='SPAN'&&!e.classList.contains('sf-fractional-stars'));
      if(old.length!==5)return;
      for(const span of old){span.textContent='';span.appendChild(oneStar(span.classList.contains('sf-review-star-empty')?0:1));}
      group.dataset.sfPointed='true';
    });
    document.querySelectorAll('.sf-fractional-stars').forEach(group=>{
      if(group.dataset.sfPointed==='true')return;
      const css=getComputedStyle(group).getPropertyValue('--sf-rating');
      const fraction=Number.parseFloat(css);
      const score=Number.isFinite(fraction)?Math.max(0,Math.min(5,fraction/20)):5;
      const all=document.createDocumentFragment();
      for(let i=0;i<5;i++)all.appendChild(oneStar(Math.max(0,Math.min(1,score-i))));
      group.replaceChildren(all);group.dataset.sfPointed='true';
    });
    document.querySelectorAll('.jdgm-rev__rating .jdgm-star,.jdgm-review-card .jdgm-star').forEach(span=>{
      if(span.dataset.sfPointed==='true')return;
      const off=span.classList.contains('jdgm--off')||span.classList.contains('jdgm-star-empty');
      span.textContent='';span.appendChild(oneStar(off?0:1));span.dataset.sfPointed='true';
    });
  };
  const mountStars=()=>{
    let pending=false;
    const schedule=()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;drawStars();});};
    schedule();
    new MutationObserver(records=>{
      if(records.some(r=>Array.from(r.addedNodes).some(n=>n.nodeType===1&&
        (n.matches?.('.sf-review-stars,.sf-fractional-stars,.jdgm-star,.sf-editorial-review')||
         n.querySelector?.('.sf-review-stars,.sf-fractional-stars,.jdgm-star')))))schedule();
    }).observe(document.body,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mountStars,{once:true});else mountStars();
})();
